import React from 'react';
import { useNostrLogin } from '@nostrify/react/login';
import NostrProvider from './NostrProvider';
import { useUserRelays } from '@/hooks/useUserRelays';

interface NostrProviderWrapperProps {
  children: React.ReactNode;
}

/**
 * Wrapper component that fetches user relays and passes them to NostrProvider.
 * This solves the chicken-and-egg problem of needing NostrContext before we can query for relays.
 */
const NostrProviderWrapper: React.FC<NostrProviderWrapperProps> = ({ children }) => {
  const { logins } = useNostrLogin();
  const currentUserPubkey = logins[0]?.pubkey;

  // Fetch user's relays from their kind 3 contact list
  const { data: userRelayData } = useUserRelays(currentUserPubkey);

  return (
    <NostrProvider
      userReadRelays={userRelayData?.readRelays}
      userWriteRelays={userRelayData?.writeRelays}
    >
      {children}
    </NostrProvider>
  );
};

export default NostrProviderWrapper;
